import type { SVGProps } from 'react';

import { SvgStroke } from '@xemplo/style-constants';
const DawnCalendar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={props.strokeWidth ?? SvgStroke.Regular}
      d="M20 10.222H4m11.556-7.11v3.555M8.444 3.11v3.556m3.613 6.74h.008m-.008 3.482h.008m3.483-3.482h.008m-.008 3.482h.008m-6.99-3.482h.008m-.008 3.482h.008m-.307 4h7.466c1.494 0 2.24 0 2.811-.29.502-.256.91-.664 1.165-1.166.291-.57.291-1.317.291-2.81V9.155c0-1.494 0-2.24-.29-2.81a2.67 2.67 0 0 0-1.166-1.166c-.57-.29-1.317-.29-2.81-.29H8.266c-1.494 0-2.24 0-2.811.29-.502.255-.91.663-1.165 1.165C4 6.915 4 7.662 4 9.155v7.467c0 1.494 0 2.24.29 2.811.256.502.664.91 1.166 1.166.57.29 1.317.29 2.81.29"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
export default DawnCalendar;
